import * as z from 'zod';
import { isoDateTimeToAppTime } from '../base-codecs';
import { LocalizedString } from '../base-schemas';
import { ReservationItemStatus } from './ReservationItemStatus';
export const ReservationOverviewItemResource = z.object({
    reservation_item_id: z.number(),
    reservation_id: z.number().nullable(),
    customer_name: z.string().nullable(),
    quantity: z.number(),
    delivery_date_time: isoDateTimeToAppTime,
    return_date_time: isoDateTimeToAppTime,
    status: ReservationItemStatus
});
export const ReservationOverviewTimeBlock = z.object({
    start_at: isoDateTimeToAppTime,
    end_at: isoDateTimeToAppTime,
    percentage: z.number(),
    active_reservation_items: z.array(ReservationOverviewItemResource)
});
export const ReservationOverviewProduct = z.object({
    id: z.number(),
    title: LocalizedString,
    is_individually_tracked: z.boolean(),
    stock_quantity: z.number().nullable(),
    time_blocks: z.array(ReservationOverviewTimeBlock)
});
export const ReservationOverviewCategory = z.object({
    id: z.number(),
    title: z.string(),
    display_order: z.number(),
    products: z.array(ReservationOverviewProduct)
});
export const ReservationOverviewResource = z.object({
    range: z.object({
        start_at: z.string(),
        end_at: z.string()
    }),
    categories: z.array(ReservationOverviewCategory)
});
